<script lang="ts">
	import { optimismTokensConfig } from '$lib/tokensConfig';
	import type { TokenSymbol } from '$lib/types/tokens';

	export let changeToken: (token: TokenSymbol) => void;
	export let token: TokenSymbol = 'sUSD';
</script>

<div
	class="modal relative flex gap-2 hover:bg-fx-grey-700 cursor-pointer px-4 py-2 rounded-lg"
	on:click={() => {
		changeToken(token);
	}}
	on:keydown={() => {
		changeToken(token);
	}}
	role="presentation"
>
	<img src={optimismTokensConfig[token].logo} loading="lazy" alt="susd" class="w-7 h-7" />

	<div class="text-fx-grey-200 text-sm font-medium">{token}</div>
</div>
